var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pannel05"},[_c('div',{staticStyle:{"border-bottom":"1px solid #ccc","font":"700 12px/40px 'simsun'","padding-left":"10px"}},[_vm._v("用户地区分布")]),_vm._v(" "),_c('div',{staticClass:"pie_show5",attrs:{"id":"pie_show6"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b4da5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/PieGraphTwo.vue
// module id = null
// module chunks = 